module.exports = __webpack_public_path__ + "img/09.half-moon-light.a35c1a3a.svg";